import type { InferenceFailureKind, TurnFailureReason } from "@t3tools/contracts";
import type { I18nKey } from "~/i18n";
import type { InferenceCredentialStatus } from "../../environments/primary/inferenceCredential";

export const MESSAGE_BY_KIND: Record<InferenceFailureKind, I18nKey> = {
  credential_rejected: "chat/yourDovodInferenceCredential_eqg3nj",
  entitlement_inactive: "chat/yourOrganizationHasNo_j0ycqk",
  credential_missing: "chat/theDovodServiceIs_edtb19",
  no_capacity: "chat/noInferenceCapacityIs_c50u7d",
  usage_limit: "chat/limitReachedTheAgent_t4g5ee",
  upstream_interrupted: "chat/theModelStoppedResponding_pgzkof",
  proxy_unreachable: "chat/theDovodInferenceService_n3eko0",
  update_required: "chat/thisVersionOfDovod_virug1",
  request_too_large: "chat/theRequestToThe_4u2sck",
  request_rejected: "chat/theDovodInferenceService_69y0x3",
};

/** A missing credential uses the account's last mint result to distinguish access from an outage. */
export function failureMessageKey(
  kind: InferenceFailureKind,
  credentialStatus: InferenceCredentialStatus,
): I18nKey {
  return kind === "credential_missing" && credentialStatus === "not-entitled"
    ? MESSAGE_BY_KIND.entitlement_inactive
    : MESSAGE_BY_KIND[kind];
}

export function turnFailureMessageKey(
  reason: TurnFailureReason,
  credentialStatus: InferenceCredentialStatus,
): I18nKey {
  switch (reason) {
    case "usage_limit":
      return "chat/turnStoppedTheAgent_zt4qxx";
    case "storage_full":
      return "chat/turnNotStartedThe_27fe0b";
    case "agent_failed":
      return "chat/theAgentCouldNot_2ijufa";
    default:
      return failureMessageKey(reason, credentialStatus);
  }
}
